"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleNoise = function VehicleNoise(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M22 8.5H2C1.86739 8.5 1.74021 8.55268 1.64645 8.64645C1.55268 8.74021 1.5 8.86739 1.5 9V15C1.5 15.1326 1.55268 15.2598 1.64645 15.3536C1.74021 15.4473 1.86739 15.5 2 15.5H22C22.1326 15.5 22.2598 15.4473 22.3536 15.3536C22.4473 15.2598 22.5 15.1326 22.5 15V9C22.5 8.86739 22.4473 8.74021 22.3536 8.64645C22.2598 8.55268 22.1326 8.5 22 8.5ZM2.5 9.5H21.5V14.5H2.5V9.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M5 10C4.60444 10 4.21776 10.1173 3.88886 10.3371C3.55996 10.5568 3.30362 10.8692 3.15224 11.2346C3.00087 11.6001 2.96126 12.0022 3.03843 12.3902C3.1156 12.7781 3.30608 13.1345 3.58579 13.4142C3.86549 13.6939 4.22186 13.8844 4.60982 13.9616C4.99778 14.0387 5.39992 13.9991 5.76537 13.8478C6.13082 13.6964 6.44318 13.44 6.66294 13.1111C6.8827 12.7822 7 12.3956 7 12C6.99939 11.4698 6.78848 10.9614 6.41354 10.5865C6.0386 10.2115 5.53025 10.0006 5 10ZM5 13C4.80222 13 4.60888 12.9414 4.44443 12.8315C4.27998 12.7216 4.15181 12.5654 4.07612 12.3827C4.00043 12.2 3.98063 11.9989 4.01922 11.8049C4.0578 11.6109 4.15304 11.4327 4.29289 11.2929C4.43275 11.153 4.61093 11.0578 4.80491 11.0192C4.99889 10.9806 5.19996 11.0004 5.38268 11.0761C5.56541 11.1518 5.72159 11.28 5.83147 11.4444C5.94135 11.6089 6 11.8022 6 12C5.99971 12.2651 5.89426 12.5193 5.70678 12.7068C5.51931 12.8943 5.26513 12.9997 5 13Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M19 10C18.6044 10 18.2178 10.1173 17.8889 10.3371C17.56 10.5568 17.3036 10.8692 17.1522 11.2346C17.0009 11.6001 16.9613 12.0022 17.0384 12.3902C17.1156 12.7781 17.3061 13.1345 17.5858 13.4142C17.8655 13.6939 18.2219 13.8844 18.6098 13.9616C18.9978 14.0387 19.3999 13.9991 19.7654 13.8478C20.1308 13.6964 20.4432 13.44 20.6629 13.1111C20.8827 12.7822 21 12.3956 21 12C20.9994 11.4698 20.7885 10.9614 20.4135 10.5865C20.0386 10.2115 19.5302 10.0006 19 10ZM19 13C18.8022 13 18.6089 12.9414 18.4444 12.8315C18.28 12.7216 18.1518 12.5654 18.0761 12.3827C18.0004 12.2 17.9806 11.9989 18.0192 11.8049C18.0578 11.6109 18.153 11.4327 18.2929 11.2929C18.4327 11.153 18.6109 11.0578 18.8049 11.0192C18.9989 10.9806 19.2 11.0004 19.3827 11.0761C19.5654 11.1518 19.7216 11.28 19.8315 11.4444C19.9414 11.6089 20 11.8022 20 12C19.9997 12.2651 19.8943 12.5193 19.7068 12.7068C19.5193 12.8943 19.2651 12.9997 19 13Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.0146 10.5H8C7.86739 10.5 7.74021 10.5527 7.64645 10.6464C7.55268 10.7402 7.5 10.8674 7.5 11V13C7.5 13.1326 7.55268 13.2598 7.64645 13.3536C7.74021 13.4473 7.86739 13.5 8 13.5H16.0146C16.1472 13.5 16.2744 13.4473 16.3682 13.3536C16.462 13.2598 16.5146 13.1326 16.5146 13V11C16.5146 10.8674 16.462 10.7402 16.3682 10.6464C16.2744 10.5527 16.1472 10.5 16.0146 10.5ZM15.5 12.5H8.5V11.5H15.5V12.5Z",
    fill: props.foregroundColor
  }));
};

VehicleNoise.defaultProps = {
  altText: "Vehicle Noise",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
VehicleNoise.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = VehicleNoise;
exports.default = _default;